<div class="login-page">
  <!-- Left Panel — Branding -->
  <div class="login-branding">
    <div class="branding-overlay"></div>
    <div class="branding-content">
      <div class="branding-logo">
        <img src="assets/Groovesheader.jpg" alt="Grooves Dental Design" class="brand-logo-img">
      </div>
      <h1 class="branding-title">Grooves Dental Design</h1>
      <p class="branding-tagline">We make it VISIBLE</p>
      <p class="branding-subtitle">Precision Prosthetics &amp; Digital Dentistry Solutions</p>
      <div class="branding-features">
        <div class="feature-item">
          <mat-icon>assignment_turned_in</mat-icon>
          <span>Job Order Management</span>
        </div>
        <div class="feature-item">
          <mat-icon>receipt_long</mat-icon>
          <span>Complete Invoicing & Billing</span>
        </div>
        <div class="feature-item">
          <mat-icon>inventory_2</mat-icon>
          <span>Product & Inventory Control</span>
        </div>
      </div>
    </div>
    <div class="branding-footer">
      <span>&copy; {{ currentYear }} Aniket Software Solutions</span>
    </div>
  </div>

  <!-- Right Panel — Login Form -->
  <div class="login-form-panel">
    <div class="form-wrapper">
      <div class="form-header">
        <div class="form-logo-mobile">
          <img src="assets/Groovesheader.jpg" alt="Logo" class="mobile-logo">
        </div>
        <h2 class="form-title">Welcome Back</h2>
        <p class="form-subtitle">Sign in to your account to continue</p>
      </div>

      <form class="login-form" (ngSubmit)="login()" autocomplete="off">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Financial Year</mat-label>
          <mat-select #financial_year_element (openedChange)="onFinancialYearScroll($event)"
                      [(value)]="selectedFinancialYear" required>
            <input class="select-input" placeholder="Search..." type="text" autocomplete="off"
                   (keydown)="$event.stopPropagation()" (keyup)="onFinancialYearKey($event)"
                   matInput name="financial_year_list">
            <mat-option *ngFor="let fy of allFinancialYears" [value]="fy.id">
              {{ fy.fy_code }}
            </mat-option>
          </mat-select>
          <mat-icon matPrefix>calendar_today</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Username</mat-label>
          <input type="text" matInput name="username" [(ngModel)]="username" required autocomplete="off">
          <mat-icon matPrefix>person</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Password</mat-label>
          <input [type]="hidePassword ? 'password' : 'text'" matInput name="password"
                 [(ngModel)]="password" required autocomplete="new-password">
          <mat-icon matPrefix>lock</mat-icon>
          <button mat-icon-button matSuffix type="button"
                  (click)="hidePassword = !hidePassword" tabindex="-1">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>

        <button mat-flat-button color="primary" type="submit" class="login-btn">
          <mat-icon>login</mat-icon>
          <span>Sign In</span>
        </button>

        <div class="form-footer">
          <a class="forgot-link">Forgot Password?</a>
        </div>
      </form>

      <div class="form-copyright">
        <span>Powered by Aniket Software Solutions</span>
      </div>
    </div>
  </div>
</div>